<template lang="html">
	<div class="patrimonial-form">
		<div class="asterisk-container">
			<div class="item">
				Quel est le montant que vous estimez nécessaire pour maintenir votre équilibre de vie ? (facultatif)
			</div>
		</div>
		<form class="form-ui landscape-patrimonial-ui" novalidate>
			<div class="form-elem-container row">
				<div class="ctn-input ctn-label three">
					<label for="montant">Montant</label>
					<input type="text" name="montant" v-model="value">
					<custom-select :items="currencies" :selected="currency" @change="currency=$event"/>
				</div>
				<div class="error-message"></div>
			</div>
			<div class="form-elem-container row">
				<div class="label input-like small">
					Périodicité
				</div>
				<custom-toggle :value='type' :values='periods' @change="type=$event"></custom-toggle>
			</div>
		</form>
	</div>
</template>

<script>
import CustomSelect from '@/common/components/Form/CustomSelect'
import CustomToggle from '@/common/components/Form/CustomToggle'
import Currency from '@/common/components/MyPatrimonialLandscape/data/Currency'
import { mapGetters } from 'vuex'

export default {
	name: 'SpendingNoTaxes',
	components: {
		CustomSelect,
		CustomToggle
	},
	data () {
		return {
			value: null,
			type: 'Mensuel',
			currency: 'EUR',
			currencies: Currency,
			periods: ['Mensuel', 'Annuel']
		}
	},
	mounted () {
		this.value = this.estate.spendingNoTaxes.value || null
		this.currency = this.estate.spendingNoTaxes.cur || 'EUR'
		this.type = (this.estate.periodicity) ? 'Mensuel' : 'Annuel'
	},
	methods: {
		validate () {
			return this.$validator.validate()
		},
		save () {
			return new Promise((resolve, reject) => {
				this.validate().then((validation) => {
					if (validation) {
						this.$store.dispatch('storePatrimonial', {
							name: 'SPENDING_NO_TAXES',
							data: {
								spending: {
									value: this.value,
									cur: this.currency
								},
								periodicity: (this.type === 'Mensuel')
							},
							fromStart: false
						}).then(() => {
							resolve()
						})
					}
				})
			})
		}
	},
	beforeDestroy () {
		this.save()
	},
	computed: {
		...mapGetters({
			estate: 'estate'
		})
	}
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// SpendingNoTaxes.vue?81d11816